import { useClientPortalAPI } from "@certn/api";
import { rem } from "@certn/cascadia";
import { Text } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { CaseCard } from "../../../components/case-card/CaseCard";
import { joinNameParts } from "../../group-overview/utils";

interface Props {
  caseId: string | undefined;
}
export function LinkedCases({ caseId }: Props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data } = useClientPortalAPI(
    `/api/internal/client-portal/case/${caseId}/linked-cases/`
  );
  return (
    <div className={styles.container}>
      <Text style="global/title-small">{t("Linked cases")}</Text>
      <div className={styles.linkedCasesContainer}>
        {data?.length === 1 ? (
          <Text style="global/heading-medium">{t("Co-applicant")}</Text>
        ) : (
          <Text style="global/heading-medium">{t("Co-applicants")}</Text>
        )}
        {data?.map((linkedCase, i) => {
          return (
            <CaseCard
              caseID={linkedCase.short_id}
              subtitle={
                joinNameParts(linkedCase.applicant_name) ||
                linkedCase.invite_email_address
              }
              linkedCases={[]}
              status={linkedCase.overall_status}
              decision={linkedCase.decision}
              score={linkedCase.overall_score}
              orderedDate={linkedCase.created}
              tags={linkedCase.tag_set?.map((tag) => tag.name)}
              checks={[
                ...(linkedCase.check_set.map((tag) => tag.type_display) || []),
              ]}
              positionLocation={linkedCase.position_location}
              key={linkedCase.short_id}
              onViewCase={() => {
                navigate(`/case-details/${linkedCase.short_id}`);
              }}
              rescreenFrequency=""
              refreshData={() => {}}
            />
          );
        })}
      </div>
    </div>
  );
}

const styles = {
  container: css({
    display: "flex",
    flexDirection: "column",
    gap: rem("space-6"),
    paddingRight: rem("space-5"),
    paddingLeft: rem("space-5"),
    paddingTop: rem("space-6"),
    paddingBottom: rem("space-6"),
  }),
  linkedCasesContainer: css({
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-2)",
  }),
};
